/**
 * File image-with-copy-slider.js.
 * Handles slider functionality on Image With Copy Slider module
 */

function imageWithCopySlider($) {
  const sliderSections = document.getElementsByClassName("image-copy-slider");
  const isRebrandedPage = document.querySelector('body').classList.contains('page--rebranded') ? true : false;

  function initSlider(slider) {
    const addArrows = slider.getAttribute("data-arrows");
    const addArrowsDesktop = slider.getAttribute("data-arrows-desktop");
    const hideDots = slider.getAttribute("data-dots");
    const hideDotsDesktop = slider.getAttribute("data-dots-desktop");
    const useToggle = slider.getAttribute("data-toggle");
    const autoplay = slider.getAttribute("data-autoplay");
    const extendSlides = slider.getAttribute("data-extend") || false;
    const sliderNumber = slider.getAttribute("data-slides");
    const twoCol = slider.getAttribute("data-two-cols");
    const slidesToShow = parseInt(slider.getAttribute("data-show")) || 1;
    const isRebrandVariant = slider.getAttribute("data-rebrand-variant");
    const slickSlidesToShow = isRebrandVariant || isRebrandedPage ? 1 : slidesToShow;
    const sliderWrapper = slider.parentElement;
    const dotsSelector = ".image-copy-slider__dots[data-slides='" + sliderNumber + "']";

    let mobileOptions = {
      slidesToShow: 1,
    };

    let slideOptions = {
      infinite: true,
      fade: true,
      speed: 0,
      slidesToShow: slickSlidesToShow,
      slidesToScroll: 1,
      adaptiveHeight: false,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnDotsHover: true,
      lazyLoad: "anticipated",
    };

    if ((isRebrandVariant || isRebrandedPage) && extendSlides) {
      slideOptions["variableWidth"] = true;
    }

    if (addArrows) {
      slideOptions["arrows"] = true;
      slideOptions["nextArrow"] =
        sliderWrapper.querySelectorAll(dotsSelector + " .next-arrow");
      slideOptions["prevArrow"] =
        sliderWrapper.querySelectorAll(dotsSelector + " .prev-arrow");

      if (addArrowsDesktop) mobileOptions["arrows"] = false;
    } else {
      slideOptions["arrows"] = false;
    }

    if (!hideDots || useToggle) slideOptions["dots"] = true;

    const buildDotSelector = (screen) => {
      let dotsWrapperSelector = dotsSelector + " .image-copy-slider__dots-wrapper";

      if (!twoCol) {
        return dotsWrapperSelector;
      }

      let hideClass = screen === 'desktop'
        ? 'hide-mobile'
        : 'hide-desktop';
      return `.${hideClass} ${dotsWrapperSelector}`;
    };

    if (!hideDots && !useToggle) {
      const dotSelector = buildDotSelector('desktop');
      slideOptions["appendDots"] = sliderWrapper.querySelector(dotSelector);
    }

    if ((hideDotsDesktop && !useToggle) || (twoCol && !useToggle)) {
      const mobileDotSelector = buildDotSelector('mobile');
      mobileOptions["appendDots"] = sliderWrapper.querySelector(mobileDotSelector);
    }

    if (!autoplay) slideOptions["autoplay"] = false;

    if (extendSlides || slidesToShow == 2) {
      slideOptions["infinite"] = false;
      slideOptions["fade"] = false;
      slideOptions["speed"] = 500;
    }

    slideOptions["responsive"] = [
      {
        breakpoint: 860,
        settings: mobileOptions,
      },
    ];

    const $slider = $(slider);

    $slider.on("init", function (event, slider) {
      onSliderInit(slider, useToggle);
    });

    $slider.slick(slideOptions);
  }

  function onSliderInit(slider, useToggle) {
    const dots = slider.$dots;
    if (dots) {
      const type = useToggle ? "TOGGLE" : "DOTS";
      dots.on("click", function (e) {
        segmentTrackModuleElementClicked(e, type);
      });
    }
  }

  function toggleSliders(toggler, sliderSectionSliders) {
    const dataSlidesToggler = toggler.dataset.slides;

    for (i = 0; i < sliderSectionSliders.length; i++) {
      const slider = sliderSectionSliders[i];
      const dataSlidesSlider = slider.dataset.slides;
      const sliderWrapper = slider.parentElement;

      if (dataSlidesToggler == dataSlidesSlider) {
        slider.classList.remove("image-copy-slider__slides--hide");
        sliderWrapper.querySelector(".image-copy-slider__dots[data-slides='" + dataSlidesSlider + "']").classList.remove(
          "image-copy-slider__dots--hide"
        );

        if (!slider.classList.contains("image-copy-slider__slides--hide")) {
          $(slider).slick("slickGoTo", 0);
          $(slider).slick("refresh"); // refresh slick since it may have been initialized while hidden
        }
      } else {
        slider.classList.add("image-copy-slider__slides--hide");
        sliderWrapper.querySelector(".image-copy-slider__dots[data-slides='" + dataSlidesSlider + "']").classList.add(
          "image-copy-slider__dots--hide"
        );
      }
    }
  }

  function toggleToggler(toggler) {
    toggler
      .closest(".toggle")
      .querySelector(".toggle__btn--active")
      .classList.remove("toggle__btn--active");
    toggler.classList.add("toggle__btn--active");
  }

  function initToggler(sliderSection, sliderSectionSliders) {
    const slideToggle = sliderSection.querySelector(".toggle");

    if (slideToggle && sliderSectionSliders.length > 1) {
      const toggler = slideToggle.querySelectorAll(".toggle__btn");

      for (var t = 0; t < toggler.length; t++) {
        toggler[t].addEventListener("click", function (e) {
          toggleToggler(e.target);
          toggleSliders(e.target, sliderSectionSliders);
          segmentTrackModuleElementClicked(e, 'TOGGLE');
        });
      }
    }
  }

  for (var i = 0; i < sliderSections.length; i++) {
    const sliderSection = sliderSections[i];
    const sliderSectionSliders = sliderSection.querySelectorAll(
      ".image-copy-slider__slides"
    );
    initToggler(sliderSection, sliderSectionSliders);

    sliderSectionSliders.forEach(slider => {
      // use setTimeout to initialize each slider in its own JS task to avoid long-running JS tasks
      setTimeout(initSlider, 0, slider);
    });
  }
}

// Inits
if (typeof jQuery !== "undefined") {
  jQuery(function ($) {
    imageWithCopySlider($);
  });
}
